import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, Check, ChevronRight, Zap, Flame, Clock, ShieldCheck, Sparkles } from 'lucide-react';
interface UpsellPurchaseProps {
  spots: number;
  joinedCount: number;
}
export function UpsellPurchase({
  spots,
  joinedCount
}: UpsellPurchaseProps) {
  const [selectedTier, setSelectedTier] = useState(1);
  const [selectedExtraKit, setSelectedExtraKit] = useState('radiestesia');
  const [timeLeft, setTimeLeft] = useState('14:43');
  // Timer logic
  useEffect(() => {
    const timer = setInterval(() => {
      const [mins, secs] = timeLeft.split(':').map(Number);
      if (mins === 0 && secs === 0) return;
      let newMins = mins;
      let newSecs = secs - 1;
      if (newSecs < 0) {
        newMins -= 1;
        newSecs = 59;
      }
      setTimeLeft(`${String(newMins).padStart(2, '0')}:${String(newSecs).padStart(2, '0')}`);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const tiers = [{
    id: 1,
    title: 'Solo Constelación Familiar Terapéutica',
    price: '19.990',
    oldPrice: '59.900',
    description: 'Guía Constelación Familiar Terapéutica PDF + 5 Bonos',
    badge: null
  }, {
    id: 2,
    title: 'Guía Constelación Familiar + 1 Kit Opcional',
    price: '29.990',
    oldPrice: '79.900',
    description: 'Elegí un kit adicional para complementar tu formación',
    badge: 'MÁS ELEGIDO'
  }, {
    id: 3,
    title: 'PORTAL TERAPÉUTICO COMPLETO ✨',
    price: '39.990',
    oldPrice: '99.990',
    description: 'Acceso total: Constelaciones + Radiestesia + Reiki + Tarot + Todos sus bonos',
    badge: 'MEJOR VALOR 🔥'
  }];
  const extraKits = [{
    id: 'radiestesia',
    name: 'Kit Radiestesia Profesional',
    icon: '⚡'
  }, {
    id: 'constelaciones',
    name: 'Kit Reiki Profesional',
    icon: '🌸'
  }, {
    id: 'tarot',
    name: 'Kit Tarot Terapéutico',
    icon: '🔮'
  }];
  const getTierImage = () => {
    switch (selectedTier) {
      case 1:
        return 'https://cdn.magicpatterns.com/uploads/5VCzCikRCrmivshx868yTg/3fb58353-4ad6-48eb-9650-c6e23b130f14.webp';
      case 2:
        if (selectedExtraKit === 'constelaciones') {
          return 'https://cdn.magicpatterns.com/uploads/9QYyXAwynRUHkQM3Qc8pQ1/ChatGPT_Image_27_may_2026,_15_37_22.webp';
        }
        if (selectedExtraKit === 'radiestesia') {
          return 'https://cdn.magicpatterns.com/uploads/v6kRZf3jNj4e4TB6hjAK9D/05393dcc-e8a9-4158-8638-bcd33da82c23.webp';
        }
        if (selectedExtraKit === 'tarot') {
          return 'https://cdn.magicpatterns.com/uploads/o2XCPLtjmFwNJTm4HqkEvR/6e7f317b-cb85-4de6-a3fe-bd663b8856bd.webp';
        }
        return 'https://cdn.magicpatterns.com/uploads/8RK1DxmEDW9bikSa4Hmuhy/3fb58353-4ad6-48eb-9650-c6e23b130f14.webp';
      case 3:
        return 'https://cdn.magicpatterns.com/uploads/urh4QhywUBB2Z3RZL3ii3v/ChatGPT_Image_27_may_2026,_15_23_37.webp';
      default:
        return 'https://cdn.magicpatterns.com/uploads/5VCzCikRCrmivshx868yTg/3fb58353-4ad6-48eb-9650-c6e23b130f14.webp';
    }
  };
  const handleCheckout = () => {
    let checkoutUrl = '';
    if (selectedTier === 1) {
      checkoutUrl = 'https://codex-labs.shop/cart/43433734733883:1';
    }
    if (selectedTier === 3) {
      checkoutUrl = 'https://codex-labs.shop/cart/43552261701691:1';
    }
    if (selectedTier === 2 && selectedExtraKit === 'radiestesia') {
      checkoutUrl = 'https://codex-labs.shop/cart/43553639530555:1';
    }
    if (selectedTier === 2 && selectedExtraKit === 'constelaciones') {
      checkoutUrl = 'https://codex-labs.shop/cart/43552280313915:1';
    }
    if (selectedTier === 2 && selectedExtraKit === 'tarot') {
      checkoutUrl = 'https://codex-labs.shop/cart/43553649524795:1';
    }
    if (checkoutUrl) {
      window.location.href = checkoutUrl;
    }
  };
  return <section id="purchase" className="py-20 px-4 bg-[#fdfbf7] pt-[15px] pb-[15px]" data-id="element-211">
      <div className="max-w-[440px] mx-auto bg-white rounded-[3rem] shadow-[0_20px_50px_rgba(124,58,237,0.1)] border border-[#f3e8ff] overflow-hidden" data-id="element-212">
        <div className="p-8 text-center pt-[15px] pb-[15px] pl-[10px] pr-[10px]" data-id="element-213">
          {/* Social Proof Header */}
          <div className="mb-[10px]" data-id="element-214">
            <p className="text-[#a78bfa] font-black text-sm tracking-widest uppercase mb-2" data-id="element-215">
              + {joinedCount} ALUMNOS
            </p>
            <div className="flex justify-center gap-1 text-yellow-400 mb-1" data-id="element-216">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-217" />)}
            </div>
            <p className="text-[#a78bfa] text-sm font-bold" data-id="element-218">(1.728 reseñas)</p>
          </div>

          <div className="inline-block bg-[#fffbeb] text-[#92400e] px-6 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest mb-8 border border-[#fef3c7]" data-id="element-219">
            ECOSISTEMA TERAPÉUTICO PROFESIONAL
          </div>

          <div className="mb-[10px]" data-id="element-220">
            <h2 className="text-[#1e1b4b] font-['Playfair_Display',_serif] text-[28px] md:text-[32px] font-bold leading-tight mb-1" data-id="element-221">
              Elegí el camino terapéutico
            </h2>
            <span className="text-[#d97706] font-['Dancing_Script',_cursive] block text-[36px] md:text-[42px] leading-none" data-id="element-222">
              que mejor conecte con vos
            </span>
            <div className="flex justify-center mt-4" data-id="element-223">
              <Sparkles className="text-[#fbbf24] w-8 h-8 opacity-60" data-id="element-224" />
            </div>
          </div>

          <p className="text-[#a78bfa] font-medium mb-10 px-8 text-[14px]" data-id="element-225">
            Accedé de forma inmediata a nuestros programas terapéuticos
            profesionales con acceso de por vida, material 100% digital en
            formato PDF descargable y futuras actualizaciones incluidas.
          </p>

          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-226">
            <span className="font-black text-[#a78bfa] uppercase tracking-[0.2em] flex gap-2 items-center justify-start text-[11px]" data-id="element-227">
              ↓ SELECCIONÁ EL PACK QUE PREFIERAS: ↓
            </span>
          </div>

          {/* Tiers List */}
          <div className="space-y-4 mb-8" data-id="element-228">
            {tiers.map(tier => <div key={tier.id} className="relative" data-id="element-229">
                {tier.badge && <div className={`absolute -top-3 right-4 z-10 px-3 py-1 rounded-full text-[9px] font-black text-white uppercase tracking-widest shadow-lg ${tier.id === 2 ? 'bg-orange-500' : 'bg-[#7c3aed]'}`} data-id="element-230">
                    ✦ {tier.badge}
                  </div>}
                <button onClick={() => setSelectedTier(tier.id)} className={`w-full text-left p-5 rounded-2xl border-2 transition-all duration-300 relative overflow-hidden ${selectedTier === tier.id ? 'border-[#7c3aed] bg-[#f5f3ff]/30 shadow-md' : 'border-[#f3e8ff] hover:border-[#ddd6fe] bg-white'}`} data-id="element-231">
                  <div className="flex items-start gap-4" data-id="element-232">
                    <div className={`mt-1 w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedTier === tier.id ? 'border-[#7c3aed] bg-[#7c3aed] text-white' : 'border-[#ddd6fe]'}`} data-id="element-233">
                      {selectedTier === tier.id && <Check size={14} strokeWidth={4} data-id="element-234" />}
                    </div>
                    <div className="flex-1" data-id="element-235">
                      <div className="flex justify-between items-start mb-1" data-id="element-236">
                        <h3 className={`font-black text-sm uppercase tracking-tight ${selectedTier === tier.id ? 'text-[#7c3aed]' : 'text-blue-950'}`} data-id="element-237">
                          {tier.title}
                        </h3>
                        <div className="text-right" data-id="element-238">
                          <p className="text-[10px] text-[#a78bfa] line-through font-bold leading-none" data-id="element-239">
                            ${tier.oldPrice}
                          </p>
                          <p className={`text-lg font-black leading-none ${selectedTier === tier.id ? 'text-[#7c3aed]' : 'text-[#319E0D]'}`} data-id="element-240">
                            ${tier.price}
                          </p>
                        </div>
                      </div>
                      <p className="text-[11px] text-blue-950/40 font-medium leading-tight" data-id="element-241">
                        {tier.description}
                      </p>
                    </div>
                  </div>
                </button>

                {/* Extra Kit Selector for Tier 2 */}
                <AnimatePresence data-id="element-242">
                  {selectedTier === 2 && tier.id === 2 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-243">
                      <div className="mt-4 p-4 bg-[#f5f3ff]/50 rounded-2xl border-2 border-[#ddd6fe] space-y-2" data-id="element-244">
                        <p className="text-[10px] font-black text-[#7c3aed] uppercase tracking-widest mb-3" data-id="element-245">
                          SELECCIONÁ TU KIT ADICIONAL:
                        </p>
                        {extraKits.map(kit => <button key={kit.id} onClick={() => setSelectedExtraKit(kit.id)} className={`w-full flex items-center justify-between p-3 rounded-xl border transition-all ${selectedExtraKit === kit.id ? 'bg-white border-[#7c3aed] shadow-sm text-[#7c3aed]' : 'bg-white/50 border-[#f3e8ff] text-[#a78bfa]'}`} data-id="element-246">
                            <div className="flex items-center gap-2 text-xs font-bold" data-id="element-247">
                              <span data-id="element-248">{kit.icon}</span>
                              {kit.name}
                            </div>
                            <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${selectedExtraKit === kit.id ? 'border-[#7c3aed] bg-[#7c3aed] text-white' : 'border-[#ddd6fe]'}`} data-id="element-249">
                              {selectedExtraKit === kit.id && <Check size={10} strokeWidth={4} data-id="element-250" />}
                            </div>
                          </button>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>

          {/* Mockup Visual */}
          <div className="mb-8 rounded-2xl overflow-hidden shadow-xl border border-[#f3e8ff]" data-id="element-251">
            <AnimatePresence mode="wait" data-id="element-252">
              <motion.img key={selectedTier} initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 1.05
            }} transition={{
              duration: 0.3
            }} src={getTierImage()} alt="Mockup Profesional" className="w-full h-auto" data-id="element-253" />
            </AnimatePresence>
          </div>

          {/* Pricing Final */}
          <div className="pb-[10px] mb-[0px]" data-id="element-254">
            <div className="inline-flex items-center gap-2 bg-[#84cc16] text-white px-6 py-2 rounded-full text-[10px] font-black uppercase tracking-widest mb-4 shadow-lg shadow-[#84cc16]/20" data-id="element-255">
              <Zap size={14} fill="currentColor" data-id="element-256" /> 50% OFF HOY
            </div>
            <h4 className="font-black text-blue-950 mb-1 text-[18px]" data-id="element-257">
              3 cuotas sin interés de
            </h4>
            <p className="font-black text-[#319E0D] text-[18px]" data-id="element-258">
              $
              {(parseInt(tiers.find(t => t.id === selectedTier)?.price.replace('.', '') || '19990') / 3).toLocaleString('es-AR', {
              maximumFractionDigits: 0
            })}
            </p>
          </div>

          {/* CTA Button */}
          <motion.button onClick={handleCheckout} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full bg-[#84cc16] hover:bg-[#74c445] text-white py-6 rounded-3xl shadow-[0_15px_30px_rgba(132,204,22,0.4)] transition-all mb-8 relative overflow-hidden group" data-id="element-259">
            <span className="relative z-10 text-3xl font-black uppercase italic tracking-tighter" data-id="element-260">
              ACCEDER AHORA
            </span>
            <motion.div animate={{
            x: ['-100%', '200%']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12" data-id="element-261" />
          </motion.button>

          {/* Footer Urgency */}
          <div className="space-y-[16px]" data-id="element-262">
            <div className="flex items-center justify-center gap-2 text-orange-500 font-bold text-sm" data-id="element-263">
              <Flame size={18} fill="currentColor" data-id="element-264" />
              ¡Últimos {spots} cupos en oferta!
            </div>

            <div className="flex flex-col items-center gap-2" data-id="element-265">
              <div className="flex items-center gap-2 text-[10px] font-black text-[#a78bfa] uppercase tracking-widest" data-id="element-266">
                <Clock size={14} data-id="element-267" />
                LA OFERTA EXPIRA EN:
                <span className="text-[#7c3aed] text-sm ml-2" data-id="element-268">{timeLeft}</span>
              </div>
              <div className="w-full h-2 bg-[#f5f3ff] rounded-full overflow-hidden border border-[#f3e8ff]" data-id="element-269">
                <motion.div initial={{
                width: '100%'
              }} animate={{
                width: '15%'
              }} transition={{
                duration: 600,
                ease: 'linear'
              }} className="h-full bg-gradient-to-r from-[#a78bfa] to-[#7c3aed]" data-id="element-270" />
              </div>
            </div>

            <div className="pt-6 flex items-center justify-center gap-2 text-[#a78bfa] text-[10px] font-bold uppercase tracking-widest" data-id="element-271">
              <ShieldCheck size={14} data-id="element-272" />
              Pago 100% Seguro y Protegido
            </div>
          </div>

          {/* Trust Section */}
          <div className="border-t-2 border-dashed border-blue-50 pt-[0px] mt-[0px] space-y-[5px]" data-id="element-273">
            <img src="https://cdn.magicpatterns.com/uploads/eU118ieSDgWuz64T6oQtAx/capture_260410_163646.png" alt="Pago Seguro Garantizado" className="w-full h-auto object-contain" data-id="element-274" />

            <div className="text-center" data-id="element-275">
              <img src="https://cdn.magicpatterns.com/uploads/skccFFLzCHBogMzzjkfEmF/7ef4071d-c511-4325-9d9d-f2158f7b8632.jpg" alt="MercadoLíder Platinum" className="w-full h-auto object-contain shadow-sm rounded-xl" data-id="element-276" />
            </div>

            <div className="bg-blue-50/50 p-4 rounded-2xl border border-blue-100" data-id="element-277">
              <p className="text-blue-950 font-black text-[10px] uppercase tracking-widest mb-3" data-id="element-278">
                Tu Compra está Protegida
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-279">
                <img src="https://cdn.magicpatterns.com/uploads/7eCtKk7WA3cLyGaeie1cdM/png-clipart-safe-purchase-payment-security-shop-shopping-online-store-e-commerce-sign-green-texta.png" alt="Compra Segura" className="h-10 object-contain" data-id="element-280" />
                <img src="https://cdn.magicpatterns.com/uploads/fpbSfdYZaTGuGJTHBKUizP/Selo_de_Garantia_de_7_Dias_PNG_Transparente_Sem_Fundo.png" alt="Garantía de 7 Días" className="h-14 object-contain" data-id="element-281" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}